import IFCM from './FirebaseCloudMessagingInterface';
import FCMNative from './FirebaseCloudMessagingNative';
import FCMBrowser from './FirebaseCloudMessagingBrowser';

const g:any = global;

// This class fetches an appropriate FCM instance
export default class FCMFactory {
    
    static instance : IFCM;
    
    static getInstance() : IFCM {
        if (this.instance) return this.instance;
        if (g.cordova) {
            // If we're running under cordova use native
            return this.instance = FCMNative.getInstance();
        } else {
            // Else use browser messaging
            return this.instance = FCMBrowser.getInstance();
        }
    }
}